export enum EONBOARDING_STEPS {
  WAITING_SCORE = -2,
  AUTH10TIX = -1,
  USER_INFO = 1,
  PAYMENT_PLAN = 2,
  PAYMENT_METHOD = 3,
  PAYMENT_SUCCESS = 4,
}

export enum EAUTH10TIX_STATUS {
  PENDING = -1,
  UNDER_REVIEW = -2,
  APPROVED = 1,
  DECLINED = 2,
  UNFINISHED = 3,
  CAM_PERMISSIONS = 4,
}
export enum CIVIL_STATUS_VALUES {
  SINGLE = 'soltero',
  MARRIED = 'casado',
  WIDOWER = 'viudo',
  DIVORCED = 'divorciado',
}

export enum EFAST_ONBOARDING_STEPS {
  DNI_FORM = 1,
  PERSONAL_FORM = 2,
}
